//https://docs.microsoft.com/nl-nl/azure/azure-maps/data-driven-style-expressions-web-sdk#aggregate-expression
import ActivityStatus from '../../../../data/ActivityStatus';
import ServiceEntryStatus from '../../../../data/ServiceEntryStatus';
export default {
    ACTIVITY: {
        order: [ActivityStatus.NONE, ActivityStatus.EXPIRED, ActivityStatus.RECENT],
        entities: ['No activity', 'Expired activity', 'Recent activity'],
        colors: ['#ec2F4B', '#F2B705', '#7FBF50'],
        properties: {
            'No activity': ['+', ['case', ['==', ['get', 'activityStatus'], ActivityStatus.NONE], 1, 0]],
            'Expired activity': ['+', ['case', ['==', ['get', 'activityStatus'], ActivityStatus.EXPIRED], 1, 0]],
            'Recent activity': ['+', ['case', ['==', ['get', 'activityStatus'], ActivityStatus.RECENT], 1, 0]]
        }
    },
    SERVICE: {
        order: [ServiceEntryStatus.Closed, ServiceEntryStatus.InProgress, ServiceEntryStatus.Created],
        entities: ['Closed', 'In progress', 'New'],
        colors: ['#12263F', '#F2B705', '#7FBF50'],
        properties: {
            'Closed': ['+', ['case', ['==', ['get', 'serviceStatus'], ServiceEntryStatus.Closed], 1, 0]],
            'In progress': ['+', ['case', ['==', ['get', 'serviceStatus'], ServiceEntryStatus.InProgress], 1, 0]],
            'New': ['+', ['case', ['==', ['get', 'serviceStatus'], ServiceEntryStatus.Created], 1, 0]]
        }
    }
};
